module.exports = __webpack_public_path__ + "static/media/bg_3.62f3a28a.jpg";